import { useCallback, useState } from 'react';

export interface UseSearchTermsResult {
  /** The committed terms, in the order they were added. */
  terms: string[];
  setTerms: (terms: string[]) => void;
  /** True once at least one term is committed. */
  hasTerms: boolean;
}

/**
 * The committed-term state behind the multi-input search, kept out of any one screen so every surface
 * that adopts the search behaves the same - same de-duplication, same casing, same shape passed
 * to the API.
 *
 * Terms are lower-cased because matching is case-insensitive server-side; keeping the
 * casing consistent stops the same search appearing as two different react-query cache keys.
 */
export const useSearchTerms = (): UseSearchTermsResult => {
  const [terms, setTermsState] = useState<string[]>([]);

  const setTerms = useCallback((nextTerms: string[]) => {
    setTermsState([...new Set(nextTerms.map((term) => term.toLowerCase()))]);
  }, []);

  return { terms, setTerms, hasTerms: terms.length > 0 };
};

export default useSearchTerms;
